import { motion } from "motion/react";
import { cn } from "./utils";

interface LoadingStateProps {
  className?: string;
  fullScreen?: boolean;
  message?: string;
}

export function BouncingDots({ color = "#0B6E4F", size = "w-1.5 h-1.5", gap = "gap-1.5" }: { color?: string; size?: string; gap?: string }) {
  return (
    <div className={cn("flex", gap)}>
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          initial={{ y: 0 }}
          animate={{ y: [-2, 2, -2] }}
          transition={{
            duration: 0.8,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.15,
          }}
          className={cn("rounded-full", size)}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
  );
}

export function LoadingState({
  className,
  fullScreen = false,
  message,
}: LoadingStateProps) {
  const containerClasses = cn(
    "flex flex-col items-center justify-center gap-4",
    fullScreen && "fixed inset-0 z-[9999] bg-[#F8FAFC]/80 backdrop-blur-sm",
    className
  );

  return (
    <div className={containerClasses}>
      <div className="relative flex flex-col items-center">
        {/* Smaller Logo */}
        <div className="w-10 h-10 rounded-full bg-[#0B6E4F] flex items-center justify-center shadow-md shadow-[#0B6E4F]/10">
          <span className="text-white font-extrabold text-lg">M</span>
        </div>
        
        {/* Bouncing dots below the logo */}
        <div className="mt-3">
          <BouncingDots />
        </div>
      </div>
      
      {message && (
        <p className="text-[#6B7280] text-xs font-semibold mt-2">
          {message}
        </p>
      )}
    </div>
  );
}
